const ACTIVE_VERSION_SUFFIX = " ★ (Published)";

export const isActiveVersionLabel = (label?: string): boolean =>
  label?.endsWith(ACTIVE_VERSION_SUFFIX) ?? false;

export const stripActiveVersionLabel = (label: string): string =>
  isActiveVersionLabel(label)
    ? label.slice(0, -ACTIVE_VERSION_SUFFIX.length)
    : label;

export const toActiveVersionLabel = (label: string): string =>
  `${stripActiveVersionLabel(label)}${ACTIVE_VERSION_SUFFIX}`;
